import React from 'react';
import styled from 'styled-components';
import { getInstituicaoLogo } from '../../../utils/instituicaoLogos';

const Moldura = styled.span`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #6ab8a8;
  color: white;
  font-weight: bold;
  font-size: 12px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const BadgeInstituicao = ({ instituicao }) => {
  if (!instituicao) return <Moldura title="Instituição não informada">?</Moldura>;

  const logo = getInstituicaoLogo({
    naturezaJuridica: instituicao.naturezaJuridica,
    esfera: instituicao.esfera,
  });
  const nome = `${instituicao.nome} (${instituicao.sigla})`;

  return (
    <Moldura title={nome}>
      {logo ? <img src={logo} alt={nome} /> : instituicao.sigla.slice(0, 2).toUpperCase()}
    </Moldura>
  );
};

export default BadgeInstituicao;
